import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator, ValidatorFn} from '@angular/forms';

const PRICE_RE = /^[\d]+$/;

export function positiveIntegerValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if (control.value == null) return null;

    const parsedValue = parseInt(control.value, 10);
    const valid = PRICE_RE.test(control.value) && !control.value.includes(' ') && !isNaN(parsedValue) && parsedValue > 0;
    return valid ? null : {'invalidValue': {value: control.value}};
  };
}

@Directive({
  selector: '[appPositiveInteger]',
  providers: [{provide: NG_VALIDATORS, useExisting: PositiveIntegerDirective, multi: true}]
})
export class PositiveIntegerDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): {[key: string]: any} {
    return positiveIntegerValidator()(control);
  }
}



// WEBPACK FOOTER //
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/app/directives/positive-integer.directive.ts